import { Link } from "react-router-dom";
import { allSpecials, allWorks } from "@/utils/media";
import { categoryList } from "@/mocks/categories";

const stats = [
  { value: `${allWorks.length}+`, label: "收录影视作品" },
  { value: `${categoryList.length}`, label: "影视分类频道" },
  { value: `${allSpecials.length}`, label: "精选主题专题" },
  { value: "每日", label: "内容更新频率" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
      <div className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
        <div className="grid grid-cols-1 gap-8 p-6 md:grid-cols-2 md:p-10">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-information-line" />
              关于平台
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一站式浏览你的影视世界
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              91av视频致力于为影视爱好者提供丰富多样的内容浏览体验。我们汇聚电影、电视剧、综艺等多种影视类型，
              通过清晰的分类、多维筛选与专题合集，帮助你快速找到感兴趣的作品，并了解影片的详细信息。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              站内影片信息均为演示内容，提供封面、简介、影人资料与相关推荐的完整浏览体验；播放相关功能暂未接入，
              相关按钮仅作演示说明，方便你提前感受未来的观看流程。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/movie"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-list-line" />
                开始浏览
              </Link>
              <Link
                to="/about"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-mail-line" />
                联系我们
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat, i) => (
              <div
                key={stat.label}
                className={`flex flex-col justify-center rounded-lg border border-background-200/70 p-5 ${
                  i % 3 === 1 ? "bg-secondary-100/70" : "bg-background-100/70"
                }`}
              >
                <span className="font-heading text-2xl font-bold text-primary-700 md:text-3xl">
                  {stat.value}
                </span>
                <span className="mt-1 text-xs text-foreground-600">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}